import { useEffect, useRef, useState } from 'react';
export const useDynamicImageImport = (path: string, options: UseDynamicImageImportOptions = {}): { error: Error | undefined; loading: boolean; Image: any } => {
    const ImportedIconRef = useRef(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(undefined as undefined | Error);
    const { onCompleted, onError } = options;
    useEffect(() => {
        setError(undefined);
        setLoading(true);
        var img = document.createElement('img');
        img.src = path;
        img.onload = () => {
            if (onCompleted) onCompleted(path, ImportedIconRef.current);
            setLoading(false);
        };
        img.onerror = (e) => {
            if (onError) onError(new Error(e.toString()));
        };
    }, [path]);

    return { error, loading, Image: path };
};
